import React from 'react';
import { Button } from 'antd';
import { Gap, Gutter, Link, Text, Title } from '@common/components';
import { imagePath } from '@common/services/images-service';

export function FourZeroFourPage() {
  return (
    <div className="four-zero-four-page">
      <Gutter size="xxl" direction="top">
        <Gap align="center" justify="center" vertical size="lg">
          <img
            width={175}
            alt="Trusted Works Logo"
            src={imagePath('./works-logo-dashed.png')}
          />
          <Gap align="center" justify="center" vertical>
            <Title size="h2">404 - Page not found</Title>
            <Text secondary>
              Sorry, the page you&apos;re looking for doesn&apos;t exist or
              you&apos;re trying to access with a different account.
            </Text>
          </Gap>
          <Link to="/works">
            <Button type="primary">Back Home</Button>
          </Link>
        </Gap>
      </Gutter>
    </div>
  );
}
